import(/* webpackMode: "eager" */ "/home/runner/work/ctv-web-next/ctv-web-next/src/app/[locale]/error.tsx");
